import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';

import ngettext from 'js-utils/ngettext';
import { HAS_WINDOW } from 'eventbrite_design_system/utils/dom';
import onClickOutsideHOC from 'eventbrite_design_system/utils/onClickOutsideDecorator';
import Icon from 'eventbrite_design_system/icon/Icon';

import ChevronDownChunkySvg from 'eventbrite_design_system/iconography/icons/ChevronDownChunky';
import ChevronUpChunkySvg from 'eventbrite_design_system/iconography/icons/ChevronUpChunky';

import { getLocationInfo } from '../../../utils/venue';
import EventCard from 'eventbrite_design_system/eventCard/EventCard';
import LoadingCards from 'eventbrite_design_system/eventCard/LoadingCards';
import { EVENT_PROPTYPES } from '../../../constants';

import './InteractiveMapMarkerTooltipMobile.scss';

const TooltipEventListHeader = ({ numEvents, onClick, isExpanded }) => {
    const numEventsShownText = ngettext(
        '%(numEvents)s event',
        '%(numEvents)s events',
        numEvents,
        { numEvents },
    );
    const iconType = isExpanded ? (
        <ChevronDownChunkySvg />
    ) : (
        <ChevronUpChunkySvg />
    );

    return (
        <div className="search-map--mobile__list-view__header eds-l-pad-vert-1 eds-l-pad-bot-1">
            <button // eslint-disable-line react/button-has-type
                className="search-map--mobile__list-view__header__button"
                onClick={onClick}
            >
                <div className="eds-text--center eds-text-bm">
                    {numEventsShownText}
                    <Icon type={iconType} color="grey-600" />
                </div>
            </button>
        </div>
    );
};

const EventCardSection = ({ eventCards, isExpanded, onClick, numEvents }) => {
    let component = null;

    let style = {};

    if (eventCards) {
        const eventListClasses = classNames(
            'interactive-map-marker__tooltip-mobile-event-list',
            {
                'interactive-map-marker__tooltip-mobile-event-list--expanded': isExpanded,
                'interactive-map-marker__tooltip-mobile-event-list--collapsed': !isExpanded,
            },
        );

        if (isExpanded && HAS_WINDOW) {
            const height = window.innerHeight - 90;

            style = {
                height: `${height}px`,
            };
        }

        component = (
            <div className={eventListClasses}>
                <TooltipEventListHeader
                    numEvents={numEvents}
                    onClick={onClick}
                    isExpanded={isExpanded}
                />
                <div
                    className="interactive-map-marker__tooltip-mobile-event-list__cards--container"
                    style={style}
                >
                    <div className="interactive-map-marker__tooltip-mobile-event-list__cards">
                        {eventCards}
                    </div>
                </div>
            </div>
        );
    }

    return component;
};

export class InteractiveMapMarkerTooltipMobile extends React.PureComponent {
    static propTypes = {
        selectedEvents: PropTypes.arrayOf(PropTypes.shape(EVENT_PROPTYPES)),
        parentIsFixed: PropTypes.bool,
        isAuthenticated: PropTypes.bool,
        onSaveEvent: PropTypes.func,
        onClick: PropTypes.func,
        // eslint-disable-next-line react/forbid-prop-types
        markerRef: PropTypes.object,
        numEvents: PropTypes.number,
        isLoading: PropTypes.bool,
    };

    static defaultProps = {
        onClick: noop,
    };

    state = {
        isExpanded: false,
    };

    _getEventCards = () => {
        const {
            isLoading,
            selectedEvents,
            onSaveEvent,
            onClick,
            isAuthenticated,
        } = this.props;

        let component = null;

        if (isLoading) {
            component = <LoadingCards cardCount={1} style="list-square" />;
        }

        if (!isEmpty(selectedEvents)) {
            component = selectedEvents.map(
                ({ venueName, venueAddress, id, ...restProps }) => (
                    <EventCard
                        {...restProps}
                        id={id}
                        key={id}
                        locationInfo={getLocationInfo(venueName, venueAddress)}
                        onSaveEvent={onSaveEvent}
                        onClick={onClick.bind(null, id)}
                        isAuthenticated={isAuthenticated}
                        type="list"
                        style="standard"
                        imageStyle="fixed"
                        containerSpacingClasses="eds-l-pad-vert-2"
                    />
                ),
            );
        }

        return component;
    };

    _handleMobileListViewToggle = () => {
        const { isExpanded } = this.state;

        this.setState({ isExpanded: !isExpanded });
    };

    render() {
        const { selectedEvents, shouldShowListView } = this.props;
        const { isExpanded } = this.state;

        if (!shouldShowListView) {
            return null;
        }

        const eventCards = this._getEventCards();

        const containerClasses = classNames(
            'interactive-map-marker__tooltip-mobile-container',
            {
                'interactive-map-marker__tooltip-mobile-container--expanded': isExpanded,
            },
        );

        return (
            <div className={containerClasses}>
                <EventCardSection
                    isExpanded={isExpanded}
                    eventCards={eventCards}
                    numEvents={selectedEvents.length}
                    onClick={this._handleMobileListViewToggle}
                />
            </div>
        );
    }
}

export default onClickOutsideHOC(InteractiveMapMarkerTooltipMobile);
